import { Button, Checkbox, Grid, Typography, withStyles } from '@material-ui/core';
import React, { useEffect, useState, useCallback } from 'react';
// import ESign from 'carynhealth-library-v2/dist/Component/ESign';
import customStyle from "../../../Assets/CSS/stylesheet_UHS";
import axios from "axios";
import configurations from "../../../configurations";
import ShimmerDashboard from '../../../Assets/Loaders/ShimmerEffect';

const NextButton = withStyles(
    customStyle.doneBtn
)(Button);

const pageStyles = {
    page: {
        backgroundColor: '#f4f4f4',
        margin: '-16px -60px 0 -10px',
        // padding: '24px 40px',
        minHeight: 'calc(100vh - 82px)',
        boxSizing: 'border-box',
    },
    card: {
        backgroundColor: '#ffffff',
        padding: '28px 32px 36px',
        maxWidth: 'calc(100vw)',
    },
    header: {
        marginBottom: 24,
        backgroundColor: '#f4f4f4',
    },
    headerLabel: {
        fontSize: 12,
        color: '#757575',
        fontWeight: 400,
        marginBottom: 4,
        fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
    },
    headerValue: {
        fontSize: 18,
        fontWeight: 700,
        color: '#212121',
        fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
    },
};

const SignForm = ({ empDetails, setIsAcknowledged, setLoaderShow }) => {
    const [checkBoxFirst, setCheckBoxFirst] = useState(false);
    const [checkBoxSecond, setCheckBoxSecond] = useState(false);
    const [pdfLink, setPdfLink] = useState("");
    const [fullName, setFullName] = useState("");
    const [signatureImage, setSignatureImage] = useState(null);
    const [disableAuthSubmit, setDisableAuthSubmit] = useState(true);
    const [isSaved, setIsSaved] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const checkAuthEnable = useCallback(() => {
        if (checkBoxFirst && checkBoxSecond && fullName && signatureImage) {
            setDisableAuthSubmit(false);
        } else {
            setDisableAuthSubmit(true);
        }
    }, [checkBoxFirst, checkBoxSecond, fullName, signatureImage]);

    useEffect(() => {
        checkAuthEnable();
    }, [checkAuthEnable]);

    useEffect(() => {
        axios
            .get(`${configurations.baseUrl}/employer/employerOrganizationDocList`)
            .then((res) => {
                const docLink = res?.data?.response?.learningList?.[0]?.data?.docLink;
                if (docLink) {
                    setPdfLink(docLink);
                }
            })
            .catch((err) => {
                console.error('employerOrganizationDocList', err);
            });
    }, []);

    const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(",")[1]);
        const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    const resolveSignatureBlob = (image) => {
        if (!image) {
            return null;
        }
        if (image instanceof Blob) {
            return image;
        }
        if (typeof image === 'string' && image.startsWith('data:')) {
            return dataURItoBlob(image);
        }
        return null;
    };

    const uploadImage = async (file) => {
        const formData = new FormData();
        formData.append("file", file, `${new Date().getTime()}.png`);

        const res = await axios.post(
            configurations.baseUrl + "/employer/uploadEmployerImage",
            formData
        );
        return res.data.response;
    };

    const authorize = async () => {
        setSubmitError('');
        setIsSaved(false);

        const signatureBlob = resolveSignatureBlob(signatureImage);
        if (!signatureBlob) {
            setSubmitError('Please complete your e-signature.');
            return;
        }

        setLoaderShow(true);

        try {
            // Upload the e-signature image first; the returned URL is then
            // sent as `esign` to updateEmployerAck.
            const imageUrl = await uploadImage(signatureBlob);

            const data = {
                empid: empDetails.empid,
                authName: fullName,
                esign: imageUrl,
                acknowledgement: true,
            };

            const response = await axios.post(
                configurations.baseUrl + '/employer/updateEmployerAck',
                data
            );

            if (response.data && response.data.code === 200) {
                setIsSaved(true);
                setIsAcknowledged(true);
            } else {
                setSubmitError((response.data && response.data.message) || 'Unable to save acknowledgement.');
            }
        } catch (err) {
            console.error('authorize', err);
            setSubmitError(
                (err && err.message) || 'An error occurred while submitting. Please try again.'
            );
        } finally {
            setLoaderShow(false);
        }
    };

    return (
        empDetails?.empid ?
        <div style={pageStyles.page}>
            <div style={pageStyles.card}>
            <Grid container spacing={4} style={pageStyles.header}>
                <Grid item xs={12} sm={6}>
                    <Typography style={pageStyles.headerLabel}>Employer Name</Typography>
                    <Typography style={pageStyles.headerValue}>
                        {empDetails.companyName || '—'}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Typography style={pageStyles.headerLabel}>Employer ID</Typography>
                    <Typography style={pageStyles.headerValue}>
                        {empDetails.empid || '—'}
                    </Typography>
                </Grid>
            </Grid>
            <div>
                <Grid container>
                    <span>Please read and indicate your acceptance of the statements linked below. Then, when you’re ready, click SUBMIT.</span>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "5px" }}>
                    <Grid item xs={2}>
                        <Checkbox
                            checked={checkBoxFirst}
                            inputProps={{ "aria-label": "secondary checkbox" }}
                            style={{ color: "#533278", marginLeft: -12 }}
                            onClick={() => setCheckBoxFirst(!checkBoxFirst)}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            marginLeft: "30px",
                            marginTop: "-36px",
                            fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                        }}
                    >
                        <span>I CONFIRM that the billing account information, that I or a representative submitted to Vera Benefitsis correct and that I authorize Vera Benefitsto initiate debit entries from the account provided.</span>
                    </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginTop: "5px" }}>
                    <Grid item xs={2}>
                        <Checkbox
                            checked={checkBoxSecond}
                            inputProps={{ "aria-label": "secondary checkbox" }}
                            style={{ color: "#533278", marginLeft: -12 }}
                            onClick={() => setCheckBoxSecond(!checkBoxSecond)}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        style={{
                            marginLeft: "30px",
                            marginTop: "-36px",
                            fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                        }}
                    >
                        <span>
                            I have READ, I UNDERSTAND, I ACKNOWLEDGE, I ACCEPT and I AGREE with the employer attestations and agreements on Vera Benefitsprograms and{' '}
                            {pdfLink ? (
                                <a
                                    href={pdfLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: "#1a2c40", cursor: 'pointer' }}
                                >
                                    Courtesy Payroll Deductions
                                </a>
                            ) : (
                                <span style={{ color: "#1a2c40" }}>Courtesy Payroll Deductions</span>
                            )}
                            .
                        </span>
                    </Grid>
                </Grid>
            </div>
            <div style={{ marginTop: 35 }}>
                {/* <ESign
                    header="Authorization for employer"
                    title="By typing my name above, I understand and agree that this form of electronic signature has the same legal force and affect as a manual signature."
                    flexDirection="row"
                    setName={(v) => setFullName(v || '')}
                    setImage={(v) => setSignatureImage(v || null)}
                /> */}
                {submitError ? (
                    <p className="a-errorMessage" style={{ marginTop: 10 }}>{submitError}</p>
                ) : null}
                <Grid xl={2} lg={4} md={5} sm={6} xs={8} item={true} style={customStyle.EnrollNew2Visit}>
                    <NextButton
                        style={{
                            margin: '35px 10px 0px 0px',
                            width: '120px',
                            height: '40px',
                            backgroundColor: disableAuthSubmit || isSaved ? '#f8f8f8' : '#1a2c40',
                            color: disableAuthSubmit || isSaved ? '#000' : '#fff',
                        }}
                        disabled={disableAuthSubmit || isSaved}
                        onClick={() => authorize()}
                    >
                        SUBMIT
                    </NextButton>
                </Grid>
            </div>
            </div>
        </div>
        :
        <ShimmerDashboard />
    )
}

export default SignForm
